import { message, notification } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};


const updateNotificationSuccess = () => {
  notification.success({
    message: 'Question Reviewed Successfully',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Q & A deleted successfully',
  });
};

const deleteNotificationFailed = () => {
  notification.error({
    message: 'Q & A deletion failed',
  });
};

const {
  generateQuestionsPostBegin,
  generateQuestionsPostSuccess,
  generateQuestionsPostErr,

  generateQuestionsReadBegin,
  generateQuestionsReadSuccess,
  generateQuestionsReadErr,

  QAUpdateBegin,
  QAUpdateSuccess,
  QAUpdateErr,

  getQuestionsBegin,
  getQuestionsSuccess,
  getQuestionsErr,

  deleteQABegin,
  deleteQASuccess,
  deleteQAErr,

  answerEvaluateBegin,
  answerEvaluateSuccess,
  answerEvaluateErr,

  getAttemptedQABegin,
  getAttemptedQASuccess,
  getAttemptedQAErr,

  generateUnitWiseQABegin,
  generateUnitWiseQASuccess,
  generateUnitWiseQAErr,

  UnitWiseQAReadBegin,
  UnitWiseQAReadSuccess,
  UnitWiseQAReadErr,

  UnitQAUpdateBegin,
  UnitQAUpdateSuccess,
  UnitQAUpdateErr,

  deleteUnitQABegin,
  deleteUnitQASuccess,
  deleteUnitQAErr,

  addNewQuestionBegin,
  addNewQuestionSuccess,
  addNewQuestionErr,

  getUnitAttemptedQABegin,
  getUnitAttemptedQASuccess,
  getUnitAttemptedQAErr,

  addEvaluationFeedbackBegin,
  addEvaluationFeedbackSuccess,
  addEvaluationFeedbackErr,

} = actions;


const generateQuestionsDataSubmit = (formData) => {
  return async (dispatch) => {
    try {
      await dispatch(generateQuestionsPostBegin());
      const response = await DataService.post('/topicmaster/text-to-QnA-New', formData);
      const token = getItem('access_token');
      const data = response.data
      if (token && data !== null && data.Error === false) {
        await dispatch(generateQuestionsPostSuccess(data));
        // questionGenerationSuccess()
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(generateQuestionsPostSuccess(null));
          dispatch(logOut())
        }
        else {
          message.error(data.message)
          await dispatch(generateQuestionsPostSuccess(null));
        }
      }
      else {
        await dispatch(generateQuestionsPostErr('Unauthorized access'));
        addNotificationError('Unauthorized access');
      }
    } catch (err) {
      await dispatch(generateQuestionsPostErr(err));
      addNotificationError(err);
    }
  };
};

const generateQuestionsDataRead = (topicId) => {
  return async (dispatch) => {
    try {
      await dispatch(generateQuestionsReadBegin());
      const query = await DataService.get(`/topicmaster/qa/${topicId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(generateQuestionsReadSuccess(data.payload));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(generateQuestionsReadSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(generateQuestionsReadSuccess(null));
        }
      }
      else {
        await dispatch(generateQuestionsReadSuccess(null));
        // await dispatch(generateQuestionsErr('Unauthorized access'));
      }
    } catch (err) {
      await dispatch(generateQuestionsReadErr(err));
    }
  };
};

const addNewSingleQuestion = (formData) => {
  return async (dispatch) => {
    try {
      await dispatch(addNewQuestionBegin());      
      const query = await DataService.post(`/topicmaster/singleqa`, formData);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        message.success(data.message)
        await dispatch(addNewQuestionSuccess(data));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(addNewQuestionSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(addNewQuestionSuccess(null));
        }
      }
      else {
        message.error(data.message)
        await dispatch(addNewQuestionSuccess(null));
        // await dispatch(generateQuestionsErr('Unauthorized access'));
      }
    } catch (err) {
      await dispatch(addNewQuestionErr(err));
    }
  };
};

const QADataUpdate = (topicId, formData) => {
  return async (dispatch) => {
    try {
      await dispatch(QAUpdateBegin());
      // /topicmaster/updateqa/${topicId}
      const response = await DataService.put(`/qamaster/update`, formData);
      const token = getItem('access_token');
      const data = response.data
      if (token && data !== null && data.Error === false) {
        await dispatch(QAUpdateSuccess(data));
        updateNotificationSuccess();
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(QAUpdateSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(QAUpdateSuccess(null));
        }
      }
      else {
        await dispatch(QAUpdateSuccess(null));
      }
    } catch (err) {
      await dispatch(QAUpdateErr(err));
      updateNotificationError(err);
    }
  };
};


const getQAByTopic = (topicId) => {
  return async (dispatch) => {
    try {
      await dispatch(getQuestionsBegin());
      const query = await DataService.get(`/topicmaster/questions/${topicId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(getQuestionsSuccess(data.payload));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(getQuestionsSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(getQuestionsSuccess(null));
        }
      }
      else {
        await dispatch(getQuestionsSuccess(null));
      }
    } catch (err) {
      await dispatch(getQuestionsErr(err));
    }
  };
};

const deleteQA = (questionId, topicId) => {
  return async (dispatch) => {
    try {
      await dispatch(deleteQABegin());
      const query = await DataService.delete(`/topicmaster/qa/delete/${topicId}/${questionId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token) {
        await dispatch(deleteQASuccess(query.data));
        if (query.data.message === "deleted") {
          deleteNotificationSuccess()
        }
        else if (query.data.message === "error in deleting") {
          deleteNotificationFailed()
        }
        else if (data !== null && data.Error === true) {
          if (Object.keys(data).length >= 3 && data.statusCode == 401) {
            message.error(data.message)
            await dispatch(deleteQASuccess(null));
            dispatch(logOut())
          }
          else {
            await dispatch(deleteQASuccess(null));
          }
        }
      } else {
        await dispatch(deleteQASuccess(null));
        // await dispatch(generateQuizErr('Unauthorized access'));
      }
    } catch (err) {
      await dispatch(deleteQAErr(err));
    }
  };
}


const EvaluateAnswer = (answers) => {
  return async (dispatch) => {
    try {
      await dispatch(answerEvaluateBegin());
      const query = await DataService.post(`/flask`, answers);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(answerEvaluateSuccess(data.payload));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(answerEvaluateSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(answerEvaluateSuccess(null));
        }
      }
      else {
        await dispatch(answerEvaluateSuccess(null));
      }
    } catch (err) {
      await dispatch(answerEvaluateErr(err));
    }
  };
};

// student 
const GetAttemptedQ = (topicId) => {
  return async (dispatch) => {
    try {
      await dispatch(getAttemptedQABegin());
      const query = await DataService.get(`/qa-attempts/evaluation-details/${topicId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(getAttemptedQASuccess(data.payload));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(getAttemptedQASuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(getAttemptedQASuccess(null));
        }
      }
      else {
        await dispatch(getAttemptedQASuccess(null));
      }
    } catch (err) {
      await dispatch(getAttemptedQAErr(err));
    }
  };
}

// student 
const GetUnitAttemptedQA = (unitId) => {
  return async (dispatch) => {
    try {
      await dispatch(getUnitAttemptedQABegin());
      const query = await DataService.get(`/qa-unit-attempts/evaluation-by-unit/${unitId}`);
      // const query = await DataService.get(`/qa-attempts/evaluation-by-unit/${unitId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(getUnitAttemptedQASuccess(data.payload));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(getUnitAttemptedQASuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(getUnitAttemptedQASuccess(null));
        }
      }
      else {
        await dispatch(getUnitAttemptedQASuccess(null));
      }
    } catch (err) {
      await dispatch(getUnitAttemptedQAErr(err));
    }
  };
}

const EvaluationFeedback = (postdata) => {
  return async (dispatch) => {
    try {
      await dispatch(addEvaluationFeedbackBegin());
      const query = await DataService.post(`/qa-unit-attempts/student-feedback`,postdata);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(addEvaluationFeedbackSuccess(query.data));
        message.success(data.message)
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(addEvaluationFeedbackSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(addEvaluationFeedbackSuccess(query.data));
        }
      }
      else {
        await dispatch(addEvaluationFeedbackSuccess(null));
        // await dispatch(topicsAddErr('Unauthorized access'));
      }
    } catch (err) {
      await dispatch(addEvaluationFeedbackErr(err));
    }
  };
};


const GenerateUnitWiseQA = (postedData) => {
  return async (dispatch) => {
    try {
      await dispatch(generateUnitWiseQABegin());
      const response = await DataService.post('/unitmaster/qa', postedData);
      const token = getItem('access_token');
      const data = response.data      
      if (token && data !== null && data.Error === false) {
        await dispatch(generateUnitWiseQASuccess(data));
        // questionGenerationSuccess()
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(generateUnitWiseQASuccess(null));
          dispatch(logOut())
        }
        else {
          message.error(data.message)
          await dispatch(generateUnitWiseQASuccess(null));
        }
      }
      else {
        await dispatch(generateUnitWiseQAErr('Unauthorized access'));
        addNotificationError('Unauthorized access');
      }
    } catch (err) {
      await dispatch(generateUnitWiseQAErr(err));
      addNotificationError(err);
    }
  };
};


const getUnitwiseGeneratedQA = (unitId) => {
  return async (dispatch) => {
    try {
      await dispatch(UnitWiseQAReadBegin());
      const query = await DataService.get(`/unitmaster/unitqa/${unitId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token && data !== null && data.Error === false) {
        await dispatch(UnitWiseQAReadSuccess(data.payload));
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(UnitWiseQAReadSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(UnitWiseQAReadSuccess(null));
        }
      }
      else {
        await dispatch(UnitWiseQAReadSuccess(null));
        // await dispatch(generateQuestionsErr('Unauthorized access'));
      }
    } catch (err) {
      await dispatch(UnitWiseQAReadErr(err));
    }
  };
};

const UnitQADataUpdate = (formData) => {
  return async (dispatch) => {
    try {
      await dispatch(UnitQAUpdateBegin());
      const response = await DataService.put(`/unit-qamaster/update`, formData);
      const token = getItem('access_token');
      const data = response.data
      if (token && data !== null && data.Error === false) {
        await dispatch(UnitQAUpdateSuccess(data));
        updateNotificationSuccess();
      }
      else if (data !== null && data.Error === true) {
        if (Object.keys(data).length >= 3 && data.statusCode == 401) {
          message.error(data.message)
          await dispatch(UnitQAUpdateSuccess(null));
          dispatch(logOut())
        }
        else {
          await dispatch(UnitQAUpdateSuccess(null));
        }
      }
      else {
        await dispatch(UnitQAUpdateSuccess(null));
      }
    } catch (err) {
      await dispatch(UnitQAUpdateErr(err));
      updateNotificationError(err);
    }
  };
};


const deleteUnitQA = (questionId) => {
  return async (dispatch) => {
    try {
      await dispatch(deleteUnitQABegin());
      const query = await DataService.delete(`/unit-qamaster/${questionId}`);
      const token = getItem('access_token');
      const data = query.data
      if (token) {
        await dispatch(deleteUnitQASuccess(query.data));
        if (query.data.message === "deleted") {
          deleteNotificationSuccess()
        }
        else if (query.data.message === "error in deleting") {
          deleteNotificationFailed()
        }
        else if (data !== null && data.Error === true) {
          if (Object.keys(data).length >= 3 && data.statusCode == 401) {
            message.error(data.message)
            await dispatch(deleteUnitQASuccess(null));
            dispatch(logOut())
          }
          else {
            await dispatch(deleteUnitQASuccess(null));
          }
        }
      } else {
        await dispatch(deleteUnitQASuccess(null));
        // await dispatch(generateQuizErr('Unauthorized access'));
      }
    } catch (err) {
      await dispatch(deleteUnitQAErr(err));
    }
  };
}

export {
  generateQuestionsDataRead,
  generateQuestionsDataSubmit,
  QADataUpdate,
  getQAByTopic,
  deleteQA,
  EvaluateAnswer,
  GetAttemptedQ,
  GenerateUnitWiseQA,
  getUnitwiseGeneratedQA,
  UnitQADataUpdate,
  deleteUnitQA,
  addNewSingleQuestion,
  GetUnitAttemptedQA,
  EvaluationFeedback
};
